

export enum EnumCadastroStatus {
    TODOS = -1,
    LIBERADO = 0,
    BLOQUEADO = 1,
    DESATIVADO = 2,
}